import moment from 'moment'
import router from "../router/router"
import Cookie from "cookies-js";
import { MessageBox } from 'element-ui';
import { Operator_service } from "../services/Operator_service";
import { Manage_request_service } from "../services/Manage_request.service";

const state = {
    data_table : [],
    provider : [],
    loading : false,
    total : 0,
    cr_status_th: {
        request : 'ส่งคำร้อง',
        approve_request : 'ยืนยันคำร้อง',
        reject_request : 'ปฏิเสธคำร้อง',
        waiting : 'รอการตรวจสอบ',
        approve_edit : 'ยืนยันการแก้ไข',
        reject_edit : 'ปฏิเสธการแก้ไข'
    },
    userinfo: {},
    promotion_status : {},
    compare_table_data: [],
    mobile_schema_en : [
        'promotion_code',
        'promotion_name_th',
        'promotion_name_en',
        'promotion_category',
        'promotion_type',
        'number_of_service_days',
        'start_sale_date',
        'end_sale_date',
        'start_service_date',
        'end_service_date',
        'service_status',
        'promotion_price',
        'voice_service',
        'sms_service',
        'mms_service',
        'internet_service',
        'wifi_service',
        'other_service',
        'voice_minute',
        'voice_second',
        'voice_unlimited',
        'voice_remark_th',
        'voice_remark_en',
        'sms_amount',
        'mms_amount',
        'internet_MB',
        'internet_GB',
        'internet_unlimited',
        'internet_remark_th',
        'internet_remark_en',
        'internet_speed_Kbps',
        'internet_speed_Mbps',
        'internet_speed_remark_th',
        'internet_speed_remark_en',
        'wifi_service_th',
        'wifi_service_en',
        'other_service_th',
        'other_service_en',
        'voice_per_minute',
        'voice_per_second',
        'voice_remark',
        'sms_per_message',
        'mms_per_message',
        'internet_per_MB',
        'wifi_average',
        'other_average',
        'average_voice_service',
        'average_voice_remark_th',
        'average_voice_remark_en',
        'average_sms_service',
        'average_mms_service',
        'average_internet_service',
        'average_other_service_th',
        'average_other_service_en',
        'service_charge_type',
        'promotion_condition_th',
        'promotion_condition_en',
        'privilege_content_th',
        'privilege_content_en',
        'privilege_social_th',
        'privilege_social_en',
        'privilege_game_th',
        'privilege_game_en',
        'privilege_premium_th',
        'privilege_premium_en',
        'privilege_device_th',
        'privilege_device_en',
        'privilege_other_th',
        'privilege_other_en',
        'signal_900',
        'signal_1800',
        'signal_2100',
        'signal_other',
        'promotion_link_url',
        'promotion_ussd',
        'promotion_banner'
    ],
    mobile_schema_th : [
        'รหัสรายการส่งเสริมการขาย',
        'ชื่อรายการส่งเสริมการขาย (ภาษาไทย)',
        'ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)',
        'ประเภทบริการของรายการส่งเสริมการขาย',
        'ชนิดของรายการส่งเสริมการขาย',
        'จำนวนวันการให้บริการ',
        'วันเริ่มต้นของการเสนอขาย',
        'วันสิ้นสุดของการเสนอขาย',
        'วันเริ่มต้นของการให้บริการ',
        'วันสิ้นสุดของการให้บริการ',
        'สถานะการให้บริการ',
        'ค่าบริการเหมาจ่ายรวมตามสิทธิ์การใช้งาน (บาท)',
        'ค่าบริการเสียง (บาท)',
        'ค่าบริการ SMS (บาท)',
        'ค่าบริการ MMS (บาท)',
        'ค่าบริการอินเทอร์เน็ต (บาท)',
        'ค่าบริการ WiFi (บาท)',
        'ค่าบริการอื่น ๆ (บาท)',
        'บริการเสียง (นาที)',
        'บริการเสียง (วินาที)',
        'บริการเสียงไม่จำกัด',
        'เงื่อนไขบริการเสียง (ภาษาไทย)',
        'เงื่อนไขบริการเสียง (ภาษาอังกฤษ)',
        'บริการ SMS (ข้อความ)',
        'บริการ MMS (ข้อความ)',
        'บริการอินเทอร์เน็ต (MB)',
        'บริการอินเทอร์เน็ต (GB)',
        'บริการอินเทอร์เน็ตไม่จำกัด',
        'เงื่อนไขบริการอินเทอร์เน็ต (ภาษาไทย)',
        'เงื่อนไขบริการอินเทอร์เน็ต (ภาษาอังกฤษ)',
        'ความเร็วอินเทอร์เน็ต (Kbps)',
        'ความเร็วอินเทอร์เน็ต (Mbps)',
        'เงื่อนไขความเร็วอินเทอร์เน็ต (ภาษาไทย)',
        'เงื่อนไขความเร็วอินเทอร์เน็ต (ภาษาอังกฤษ)',
        'บริการ WiFi (ภาษาไทย)',
        'บริการ WiFi (ภาษาอังกฤษ)',
        'บริการอื่น ๆ (ภาษาไทย)',
        'บริการอื่น ๆ (ภาษาอังกฤษ)',
        'อัตราค่าบริการเฉลี่ยบริการเสียง (บาท/นาที)',
        'อัตราค่าบริการเฉลี่ยบริการเสียง (บาท/วินาที)',
        'เงื่อนไขอัตราค่าบริการเฉลี่ยบริการเสียง',
        'อัตราค่าบริการเฉลี่ยบริการ SMS (บาท/ข้อความ)',
        'อัตราค่าบริการเฉลี่ยบริการ MMS (บาท/ข้อความ)',
        'อัตราค่าบริการเฉลี่ยบริการอินเทอร์เน็ต (บาท/MB)',
        'เงื่อนไขอัตราค่าบริการเฉลี่ยบริการ WiFi',
        'เงื่อนไขอัตราค่าบริการเฉลี่ยบริการอื่น ๆ',
        'ค่าบริการต่อหน่วยบริการเสียง (บาท/นาที)',
        'คำอธิบายค่าบริการต่อหน่วยบริการเสียง (ภาษาไทย)',
        'คำอธิบายค่าบริการต่อหน่วยบริการเสียง (ภาษาอังกฤษ)',
        'ค่าบริการต่อหน่วยบริการ SMS (บาท/ข้อความ)',
        'ค่าบริการต่อหน่วยบริการ MMS (บาท/ข้อความ)',
        'ค่าบริการต่อหน่วยบริการอินเทอร์เน็ต (บาท/MB)',
        'คำอธิบายค่าบริการต่อหน่วยบริการอื่น ๆ (ภาษาไทย)',
        'คำอธิบายค่าบริการต่อหน่วยบริการอื่น ๆ (ภาษาอังกฤษ)',
        'รูปแบบการคิดค่าบริการประเภทเสียง',
        'ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)',
        'ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)',
        'สิทธิพิเศษบริการความบันเทิง (ภาษาไทย)',
        'สิทธิพิเศษบริการความบันเทิง (ภาษาอังกฤษ)',
        'สิทธิพิเศษบริการโซเชียลมีเดีย (ภาษาไทย)',
        'สิทธิพิเศษบริการโซเชียลมีเดีย (ภาษาอังกฤษ)',
        'สิทธิพิเศษบริการเกม (ภาษาไทย)',
        'สิทธิพิเศษบริการเกม (ภาษาอังกฤษ)',
        'สิทธิพิเศษบริการพรีเมียม (ภาษาไทย)',
        'สิทธิพิเศษบริการพรีเมียม (ภาษาอังกฤษ)',
        'สิทธิพิเศษบริการอุปกรณ์อื่น ๆ (ภาษาไทย)',
        'สิทธิพิเศษบริการอุปกรณ์อื่น ๆ (ภาษาอังกฤษ)',
        'สิทธิพิเศษบริการอื่น ๆ (ภาษาไทย)',
        'สิทธิพิเศษบริการอื่น ๆ (ภาษาอังกฤษ)',
        'ย่านคลื่นความถี่ 900 MHz',
        'ย่านคลื่นความถี่ 1800 MHz',
        'ย่านคลื่นความถี่ 2.1 GHz',
        'ย่านคลื่นความถี่อื่น ๆ ',
        'ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขาย',
        'หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย',
        'ลิงก์รูปโฆษณาหรือรูปรายการส่งเสริมการขาย'
    ],
    broadband_schema_en : [
        'promotion_code',
        'promotion_name_th',
        'promotion_name_en',
        'promotion_technology',
        'promotion_type',
        'start_sale_date',
        'end_sale_date',
        'start_service_date',
        'end_service_date',
        'service_status',
        'promotion_price',
        'download_speed',
        'upload_speed',
        'content_service_th',
        'content_service_en',
        'mobile_service_th',
        'mobile_service_en',
        'wifi_service_th',
        'wifi_service_en',
        'fixed_line_service_th',
        'fixed_line_service_en',
        'device_service_th',
        'device_service_en',
        'other_service_th',
        'other_service_en',
        'privilege_content_th',
        'privilege_content_en',
        'privilege_mobile_th',
        'privilege_mobile_en',
        'privilege_wifi_th',
        'privilege_wifi_en',
        'privilege_premium_th',
        'privilege_premium_en',
        'privilege_device_th',
        'privilege_device_en',
        'privilege_other_th',
        'privilege_other_en',
        'internet_per_Mbps',
        'promotion_condition_th',
        'promotion_condition_en',
        'promotion_link_url',
        'promotion_banner'
    ],
    broadband_schema_th : [
        'รหัสรายการส่งเสริมการขาย',
        'ชื่อรายการส่งเสริมการขาย (ภาษาไทย)',
        'ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)',
        'ประเภทเทคโนโลยีของการให้บริการ',
        'ชนิดของรายการส่งเสริมการขาย',
        'วันเริ่มต้นของการเสนอขาย',
        'วันสิ้นสุดของการเสนอขาย',
        'วันเริ่มต้นของการให้บริการ',
        'ว้นสิ้นสุดของการให้บริการ',
        'สถานะการให้บริการ',
        'ค่าบริการรายเดือน (บาท)',
        'ความเร็วดาวน์โหลด',
        'ความเร็วอัปโหลด',
        'บริการเสริมความบันเทิง (ภาษาไทย)',
        'บริการเสริมความบันเทิง (ภาษาอังกฤษ)',
        'บริการเสริมโทรศัพท์เคลื่อนที่ (ภาษาไทย)',
        'บริการเสริมโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)',
        'บริการเสริม WiFi/Hotspot (ภาษาไทย)',
        'บริการเสริม WiFi/Hotspot (ภาษาอังกฤษ)',
        'บริการเสริม Fixed Line (ภาษาไทย)',
        'บริการเสริม Fixed Line (ภาษาอังกฤษ)',
        'บริการเสริมอุปกรณ์อื่น ๆ (ภาษาไทย)',
        'บริการเสริมอุปกรณ์อื่น ๆ (ภาษาอังกฤษ)',
        'บริการเสริมอื่น ๆ (ภาษาไทย)',
        'บริการเสริมอื่น ๆ (ภาษาอังกฤษ)',
        'สิทธิพิเศษความบันเทิง (ภาษาไทย)',
        'สิทธิพิเศษความบันเทิง (ภาษาอังกฤษ)',
        'สิทธิพิเศษโทรศัพท์เคลื่อนที่ (ภาษาไทย)',
        'สิทธิพิเศษโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)',
        'สิทธิพิเศษ WiFi (ภาษาไทย)',
        'สิทธิพิเศษ WiFi (ภาษาอังกฤษ)',
        'สิทธิพิเศษพรีเมียม (ภาษาไทย)',
        'สิทธิพิเศษพรีเมียม (ภาษาอังกฤษ)',
        'สิทธิพิเศษอุปกรณ์อื่น ๆ (ภาษาไทย)',
        'สิทธิพิเศษอุปกรณ์อื่น ๆ (ภาษาอังกฤษ)',
        'สิทธิพิเศษอื่น ๆ (ภาษาไทย)',
        'สิทธิพิเศษอื่น ๆ (ภาษาอังกฤษ)',
        'อัตราค่าบริการต่อหน่วย (บาท/Mbps)',
        'ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)',
        'ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)',
        'ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขาย',
        'ลิงก์รูปโฆษณาหรือรูปรายการส่งเสริมการขาย'
    ],
    edit_revision : null
}

const actions = {
    
    async getProviderList({ commit },provider_type) {
        let result = await Operator_service.getProviderList(provider_type);
        if (result.status === 200) {
            commit('SET_PROVIDER_LIST', result.data)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async getMobileRequest({commit}, formdata){
        commit('LOADING',true)
        let result = await Manage_request_service.getMobileRequest(formdata)
        if(result.status == 200){
            commit('SET_DATA_TABLE',result.data)
            setTimeout(() => {
                commit('LOADING',false)
            }, 350);
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
            commit('LOADING',false)
        }
    },

    async getBroadbandRequest({commit}, formdata){
        commit('LOADING',true)
        let result = await Manage_request_service.getBroadbandRequest(formdata)
        if(result.status == 200){
            commit('SET_DATA_TABLE',result.data)
            setTimeout(() => {
                commit('LOADING',false)
            }, 350);
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
            commit('LOADING',false)
        }
    },

    async setRequestStatus({dispatch}, formdata){
        let userinfo = JSON.parse(Cookie.get('user_nbtc'))
            formdata.dialogForm.admin_id = userinfo.admin_id
        let result = formdata.dialogForm.provider_type == 'mobile' 
                    ? await Manage_request_service.addMobileRequest(formdata.dialogForm) 
                    : await Manage_request_service.addBroadbandRequest(formdata.dialogForm)
        if(result.status == 200){
            MessageBox.confirm('ดำเนินการเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            })
            if(formdata.dialogForm.cr_status == 'approve_edit'){
                Manage_request_service.updateActiveStatus({
                    revision_id : formdata.dialogForm.revision_id,
                    provider_type : formdata.dialogForm.provider_type,
                    active_status : 1
                })
            }
            dispatch('getMobileRequest',formdata.filterForm)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async getMobileRequestById({commit},promotion_id){
        let result = await Manage_request_service.getMobileRequestById({promotion_id: promotion_id})
        if(result.status === 200){
            commit('SET_PROMOTION_STATUS', result.data[0])
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async sendEditRequest({state,commit}, promotion){
        let userinfo = JSON.parse(Cookie.get('user_nbtc'))
            promotion.source = 'cms'
        let result = await Manage_request_service.addMobileEditRevision({
            promotion : promotion,
            admin_id : userinfo.admin_id,
            provider_id : userinfo.provider_id
        })
        if(result.status == 200){
            MessageBox.confirm('คำขอถูกส่งเรียบร้อย กรุณารอการตรวจสอบจากเจ้าหน้าที่', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(()=>{
                router.push({name : 'Manage_mobileOperator'})
            })
        }else{
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async getMobileEditRevision({commit}, promotion_id){
        let result = await Manage_request_service.getMobileEditRevision({
            promotion_id : promotion_id
        })
        if(result.status == 200){
            commit('SET_COMPARE_TABLE_MOBILE',result.data)
            commit('SET_EDIT_REVISION',result.data[1])
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async getBroadbandEditRevision({commit}, promotion_id){
        let result = await Manage_request_service.getBroadbandEditRevision({
            promotion_id : promotion_id
        })
        if(result.status == 200){
            commit('SET_COMPARE_TABLE_BROADBAND',result.data)
            commit('SET_EDIT_REVISION',result.data[1])
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async setBroadbandRequestStatus({dispatch}, formdata){
        let userinfo = JSON.parse(Cookie.get('user_nbtc'))
        if(userinfo.provider_id){
            formdata.dialogForm.operator_id = userinfo.admin_id
            formdata.dialogForm.provider_id = userinfo.provider_id
        }else{
            formdata.dialogForm.admin_id = userinfo.admin_id
        }
        let result = await Manage_request_service.addBroadbandRequest(formdata.dialogForm)
        if(result.status == 200){
            if(formdata.dialogForm.cr_status == 'approve_edit'){
                Manage_request_service.updateActiveStatus({
                    revision_id : formdata.dialogForm.revision_id,
                    provider_type : formdata.dialogForm.provider_type,
                    active_status : 1
                })
            }
            MessageBox.confirm('ดำเนินการเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(()=>{
                if(router.currentRoute.path.includes('Manage_internet')){
                    dispatch('Manage_internet/search_promotion', formdata.filterForm, {root: true})
                }else{
                    dispatch('getBroadbandRequest',formdata.filterForm)
                }
            })
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async addBroadbandEditRevision({state,commit}, promotion){
        let userinfo = JSON.parse(Cookie.get('user_nbtc'))
            promotion.source = 'cms'
            promotion.provider_id = userinfo.provider_id
        let result = await Manage_request_service.addBroadbandEditRevision({
            promotion : promotion,
            admin_id : userinfo.admin_id,
            provider_id : userinfo.provider_id
        })
        if(result.status == 200){
            MessageBox.confirm('คำขอถูกส่งเรียบร้อย กรุณารอการตรวจสอบจากเจ้าหน้าที่', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(()=>{
                router.push({name : 'Operator_Manage_internet'})
            })
        }else{
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async suspendPromotion({commit}, formdata){
        let userinfo = JSON.parse(Cookie.get('user_nbtc'))
            formdata.admin_id = userinfo.admin_id
            formdata.operator_id = null
        let result = formdata.type == 'mobile' ? await Manage_request_service.addMobileRequest(formdata) : await Manage_request_service.addBroadbandRequest(formdata)
        if(result.status == 200){
            await Manage_request_service.updateActiveStatus({
                promotion_name : formdata.promotion_name,
                revision_id : formdata.revision_id,
                provider_type : formdata.type,
                active_status : formdata.active_status
            })
            MessageBox.confirm('ดำเนินการเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            })
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async cancelBroadbandRequest({commit}, request_info){
        let result = await Manage_request_service.cancelBroadbandRequest(request_info)
        if(result.status == 200){
            commit('Manage_internet/UPDATE_CR_STATUS',request_info, {root: true})
            MessageBox.confirm('ดำเนินการเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            })
        }else{
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async cancelMobileRequest({commit}, request_info){
        request_info.cr_status = 'reject_request'
        let result = await Manage_request_service.cancelMobileRequest(request_info)
        if(result.status == 200){
            commit('Promotion/UPDATE_CR_STATUS',request_info, {root: true})
            MessageBox.confirm('ดำเนินการเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            })
        }else{
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    }
}

const mutations = {
    SET_PROVIDER_LIST(state, provider_list){
        state.provider = []
        for(let item of provider_list){
            state.provider.push(item)
        }
    },
    SET_DATA_TABLE(state, data){
        state.total = data[0] ? data[0].total : 0
        for(let i in data){
            data[i].created_at = moment(data[i].created_at).add(543,'Y').format('DD/MM/YYYY')
        }
        state.data_table = data
    },
    LOADING(state, status){
        state.loading = status
    },
    SET_PROMOTION_STATUS(state, iteminfo){
        state.promotion_status = iteminfo
    },
    SET_COMPARE_TABLE_MOBILE(state, items){
        state.compare_table_data = []
        for(let i in items[0]){
            if((items[0][i] !== items[1][i]) && state.mobile_schema_en.includes(i)){
                let old_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(i) && items[1][i]
                            ? moment(items[1][i]).add(543,'Y').format('DD/MM/YYYY') : items[1][i]
                let new_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(i) && items[0][i]
                            ? moment(items[0][i]).add(543,'Y').format('DD/MM/YYYY') : items[0][i]
                state.compare_table_data.push({
                    name : state.mobile_schema_th[state.mobile_schema_en.indexOf(i)],
                    old : old_item,
                    new : new_item
                })
            }
        }
    },
    SET_COMPARE_TABLE_BROADBAND(state, items){
        state.compare_table_data = []
        for(let i in items[0]){
            if((items[0][i] !== items[1][i]) && state.broadband_schema_en.includes(i)){
                let old_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(i) && items[1][i]
                            ? moment(items[1][i]).add(543,'Y').format('DD/MM/YYYY') : items[1][i]
                let new_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(i) && items[0][i]
                            ? moment(items[0][i]).add(543,'Y').format('DD/MM/YYYY') : items[0][i]
                state.compare_table_data.push({
                    name : state.broadband_schema_th[state.broadband_schema_en.indexOf(i)],
                    old : old_item,
                    new : new_item
                })
            }
        }
    },
    SET_EDIT_REVISION(state, item){
        state.edit_revision = item.id
    }
}

export const Manage_request = {
    namespaced: true,
    state,
    actions,
    mutations
}